var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.20711 0 6.375 0.195875 6.375 0.4375V8.13128L8.85983 5.23231C9.00628 5.06145 9.24372 5.06145 9.39017 5.23231C9.53661 5.40316 9.53661 5.68017 9.39017 5.85103L6.26517 9.49686C6.11872 9.66771 5.88128 9.66771 5.73483 9.49686L2.60983 5.85103C2.46339 5.68017 2.46339 5.40316 2.60983 5.23231C2.75628 5.06145 2.99372 5.06145 3.14017 5.23231L5.625 8.13128V0.4375C5.625 0.195875 5.79289 0 6 0ZM0.375 8.75C0.582107 8.75 0.75 8.94588 0.75 9.1875V12.1042C0.75 12.3749 0.842187 12.6346 1.00628 12.826C1.17038 13.0174 1.39294 13.125 1.625 13.125H10.375C10.6071 13.125 10.8296 13.0174 10.9937 12.826C11.1578 12.6346 11.25 12.3749 11.25 12.1042V9.1875C11.25 8.94588 11.4179 8.75 11.625 8.75C11.8321 8.75 12 8.94588 12 9.1875V12.1042C12 12.607 11.8288 13.0892 11.524 13.4447C11.2193 13.8003 10.806 14 10.375 14H1.625C1.19402 14 0.780698 13.8003 0.475951 13.4447C0.171205 13.0892 0 12.607 0 12.1042V9.1875C0 8.94588 0.167893 8.75 0.375 8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.6d274c227957f0e8ccbed98935c63412.svg";
export { ForwardRef as ReactComponent };